import request from '@/utils/request'

export function addPersonalApi(data) {
  return request({
    url: '/companyUser/inviteUser',
    method: 'post',
    data
  })
}

export function editPersonalApi(data) {
  return request({
    url: '/companyUser/updateCompanyUser',
    method : 'post',
    data
  })
}

export function deletePersonalApi(data) {
  return request({
    url: '/companyUser/deleteCompanyUser',
    method: 'post',
    data
  })
}
